export default __webpack_public_path__ + "static/media/156.31db2f77.gif";